import { DownloadIcon } from './DimensionerIcons'

const ScanFileRow = ({icon, label, sub, onClick, disabled}: {icon: JSX.Element, label: string, sub: string, onClick: () => void, disabled: boolean}) => (
    <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        className="d-flex align-items-center justify-content-between w-100"
        style={{height: 46, padding: '0 12px', border: `1px solid ${disabled ? '#EFF2F5' : '#E4E6EF'}`, background: disabled ? '#FBFBFD' : '#fff', borderRadius: 7, cursor: disabled ? 'not-allowed' : 'pointer'}}
    >
        <span className="d-flex align-items-center">
            <span className="d-flex align-items-center justify-content-center" style={{width: 28, height: 28, borderRadius: 6, background: disabled ? '#F5F8FA' : '#F1FAFF', color: disabled ? '#C9CCD9' : '#009EF7', flexShrink: 0}}>{icon}</span>
            <span className="d-flex flex-column align-items-start ms-3" style={{lineHeight: 1.25}}>
                <span style={{fontSize: 13, fontWeight: 500, color: disabled ? '#B5B5C3' : '#181C32'}}>{label}</span>
                <span style={{fontSize: 11, color: disabled ? '#CBCEDA' : '#A1A5B7'}}>{disabled ? 'Run a scan first' : sub}</span>
            </span>
        </span>
        <span className="d-flex align-items-center" style={{gap: 5, color: disabled ? '#CBCEDA' : '#009EF7', fontSize: 12, fontWeight: 600}}>Download<DownloadIcon size={16}/></span>
    </button>
)

export default ScanFileRow
